import HopTimusAskLineContent from './HopTimusAskLineContent/HopTimusAskLineContent'
import useHopTimusAskLineEnabled from './useHopTimusAskLineEnabled'

const HopTimusAskLine = () => {
  const enabled = useHopTimusAskLineEnabled()

  if (!enabled) return null

  return <HopTimusAskLineContent />
}

export default HopTimusAskLine
